import { Component } from '@angular/core';
import { LayoutService } from '../../shared/services/layout.service';
import { ReportService } from '../services/report.service';
//import { HistoryService } from '../services/history.service';
import { STATIC_VALUE } from '../../shared/configuration/static.value';
import { LazyLoadEvent } from 'primeng/components/common/api';
import { FilterMetadata } from 'primeng/components/common/api';

import { FileService } from './../../shared/services/file.service';

import { CONFIGURATION } from '../../shared/configuration/configuration';
declare var require: any
const FileSaver = require('file-saver');
import { Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions } from '@angular/http';
import { PopupService } from '../../shared/services/pop-up.service';
import { PlantmapAdminAllComponent } from '../../plantmap-admin/components/all.component';
import { StorageService } from '../../shared/services/storage.service';
import { NativeDateAdapter, DateAdapter, MD_DATE_FORMATS } from "@angular/material";//Added by Anjaiah
import { HistoryService } from 'app/history/services/history.service';

//Added by Anjaiah
export class AppDateAdapter extends NativeDateAdapter {

    format(date: Date, displayFormat: Object): string {
        if (displayFormat == "input") {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            return this._to2digit(day) + '/' + this._to2digit(month) + '/' + year;
        } else {
            return date.toDateString();
        }
    }

    private _to2digit(n: number) {
        return ('00' + n).slice(-2);
    }
}

export const APP_DATE_FORMATS =
{
    parse: {
        dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
    },
    display: {
        // dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    }
}
@Component({
    selector: 'admin-report',
    templateUrl: 'admin-report.component.html',
    providers: [PlantmapAdminAllComponent, {
        provide: DateAdapter, useClass: AppDateAdapter
    },
        {
            provide: MD_DATE_FORMATS, useValue: APP_DATE_FORMATS
        }], //Kowsalya
})

export class AdminReportComponent {
    vPageSize: number = STATIC_VALUE.TABLE.PAGE_SIZE;
    vLoadingPlant: boolean = false;
    vPlantSearchBy: string = '';
    vPlantFilterBy: string = '';
    vPlantStatus: string = '';
    totalPlantmapRecords: number;
    vPlantFromDate: Date;
    vPlantToDate: Date;
    vPlantFromDateFilterBy: string = '';
    vPlantToDateFilterBy: string = '';
    resettedPlantTable: number = 0;
    vRegenerateMapStatus: number = 0;

    vPageNumber: number = 0;
    vDisableButton: boolean = false;

    arr: Array<any>;

    vPlantLists: Array<{
        plant_record_id: number,
        plant_request_id: string,
        project_title: string,
        create_date: string,
        expiry_date: string,
        updated_date: string,
        location: string,
        a2_amount: string,
        status: string,
        trans_amount: string,
        restricted_area: string,
        check_status: string,
        registration_type: string,
        plant_map_s3_status: number
    }>;


    vHistoryLists: Array<{
        plant_request_id: string,
        project_title: string,
        main_contractor: string,
        transaction_record_id: string,
        purchaser_company_name: string,
        create_date: string,
        updated_date: string,
        create_by: string,
        updated_by: string
    }>;

    constructor(
        private _http: Http,
        private _ReportService: ReportService,
        private _layoutService: LayoutService,
        private _fileService: FileService,
        private _popupService: PopupService,
        private _storageService: StorageService,
        private _PlantmapAdminAllComponent: PlantmapAdminAllComponent, //Kowsalya
        private _historyService: HistoryService,

    ) { }

    ngOnInit() {

        this._layoutService.setCurrentPage('admin-report');

        this.vLoadingPlant = true;

        this._ReportService.loadTotalCustomerPlantAdmin(this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus).then(
            (resolve) => {
                this._ReportService.loadPlantmapAdmin(0, this.vPageSize, this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus, 0, "").then(
                    (resolve) => {
                        this.vLoadingPlant = false;
                        this.totalPlantmapRecords = this._ReportService.getTotalCustomerPlantmap();
                        this.vPlantLists = this._ReportService.getCustomerPlantList();
                    },
                    (reject) => {
                        this.vLoadingPlant = false;
                    }
                );
            },
            (reject) => {
                this.vLoadingPlant = false;
            }
        );

        this.vPlantSearchBy = this.getSearchBy('plantmap')[0].type;
    }

    getSearchBy(pType) {
        let data = [];
        for (let pm of STATIC_VALUE.SEARCH_BY.admin) {
            if (pm.plantValue !== '' && pType == 'plantmap') {
                data.push(pm);
            }
        }
        return data;
    }
    resetPlantFilter() {
        this.vPlantFilterBy = '';
        //this.vPlantDate = null;
        this.vPlantFromDate = null;
        this.vPlantToDate = null;
    }

    filterFromDatePlant() {
        this.vPlantFromDateFilterBy = this.vPlantFromDate.getFullYear() + '' + ("0" + (this.vPlantFromDate.getMonth() + 1)).slice(-2) + '' + ("0" + this.vPlantFromDate.getDate()).slice(-2);
        //this.filterPlant();
    }

    filterToDatePlant() {
        this.vPlantToDateFilterBy = this.vPlantToDate.getFullYear() + '' + ("0" + (this.vPlantToDate.getMonth() + 1)).slice(-2) + '' + ("0" + this.vPlantToDate.getDate()).slice(-2);
        this.filterPlantDate();
    }

    loadPlantmapLazy(event: LazyLoadEvent) {

        if (this.vLoadingPlant) {
            return;
        }

        //let vPageNumber: number= 0
        this.vPageNumber = event.first / this.vPageSize;
        this.vLoadingPlant = true;
        let sortfield = event.sortField;

        if (this.vPlantSearchBy != 'applicationDate') {

            this._ReportService.loadPlantmapAdmin(this.vPageNumber, this.vPageSize, this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus, event.sortOrder, sortfield).then(
                (resolve) => {
                    this.vLoadingPlant = false;
                    this.vPlantLists = this._ReportService.getCustomerPlantList();
                },
                (reject) => {
                    this.vLoadingPlant = false;
                }
            );
        }
        else {
            this._ReportService.loadPlantmapDateAdmin(this.vPageNumber, this.vPageSize, this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy, this.vPlantStatus, event.sortOrder, sortfield).then(
                (resolve) => {
                    this.vLoadingPlant = false;
                    this.vPlantLists = this._ReportService.getCustomerPlantList();
                },
                (reject) => {
                    this.vLoadingPlant = false;
                }
            );
        }
    }

    displayButton(pPlantID) {
        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantstatus => plantstatus.plant_record_id === pPlantID);

            if (pmByPlantID.length > 0) {
                if (pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_RECEIVED //'Payment received'
                    || pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.DONE
                    || pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.PENDING_MAP_COLLECTION
                    || pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.MAP_DELIVERED) {
                    return true;
                }
                return false;
            }
            return false;
        }
        return false;
    }

    displayDownloadButton(pPlantID) {
        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantstatus => plantstatus.plant_record_id === pPlantID);

            if (pmByPlantID.length > 0) {

                // let tempDateString:any = (pmByPlantID[0].create_date.substring(0,(pmByPlantID[0].create_date.length-2)));
                // let processDateFormat:any = tempDateString.split(' ');
                // let dateSections:any = processDateFormat[0].split('/');
                // let created_date:any = dateSections[2]+"/"+dateSections[1]+"/"+dateSections[0]+" "+processDateFormat[1];

                // let requestedDate:any = new Date(created_date);
                // let currentTimestamp:any = new Date();                
                // let difference:any = (currentTimestamp - requestedDate);
                // let diffHrs = Math.floor((difference % 86400000) / 3600000); // hours

                if (pmByPlantID[0].plant_map_s3_status == 1) {
                    return true;
                }
                else {
                    return false;
                }
            }
            return false;
        }
        return false;
    }

    isRestrictedArea(pPlantID: number): boolean {
        if (this.vPlantLists.length > 0) {
            const plant = this.vPlantLists.find(
                item => item.plant_record_id === pPlantID
            );

            if (plant) {
                return Number(plant.restricted_area) === 1;
            }
        }
        return false;
    }
isPlantMapRegenrate(pPlantID: number): boolean {
        if (this.vPlantLists.length > 0) {
            const plant = this.vPlantLists.find(
                item => item.plant_record_id === pPlantID
            );
 
            if (plant) {
                return Number(plant.plant_map_s3_status) === 1;
            }
        }
        return false;
    }

isPaymentRecived(pPlantID: number): boolean {
        if (this.vPlantLists.length > 0) {
            const plant = this.vPlantLists.find(
                item => item.plant_record_id === pPlantID
            );
 
            if (plant) {
                return plant.status == "Payment Received";
            }
        }
        return false;
    }


    displayRegenerateButton(pPlantID) {
        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantstatus => plantstatus.plant_record_id === pPlantID);

            if (pmByPlantID.length > 0) {
                let tempDateString: any = (pmByPlantID[0].create_date.substring(0, (pmByPlantID[0].create_date.length - 2)));
                let processDateFormat: any = tempDateString.split(' ');
                let dateSections: any = processDateFormat[0].split('/');
                let created_date: any = dateSections[2] + "/" + dateSections[1] + "/" + dateSections[0] + " " + processDateFormat[1];

                let requestedDate: any = new Date(created_date);
                let currentTimestamp: any = new Date();
                //let difference:any = (currentTimestamp - requestedDate);
                //let diffHrs = Math.floor((difference % 86400000) / 3600000); // hours
                let diffHrs = this.diff_hours(currentTimestamp, requestedDate);
                //if(pmByPlantID[0].restricted_area == "0"){
                //alert("restricted_area-->"+restricted_area);

                if (pmByPlantID[0].plant_map_s3_status == 2) {
                    this.vDisableButton = true;
                    return true;
                } else if (pmByPlantID[0].plant_map_s3_status == 0 && diffHrs >= 2 && pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.DONE) {
                    this.vDisableButton = false;
                    return true;
                }
                else {
                    return false;
                }
                /* }
                 else{
                     return false;
                 }*/

            }
            return false;
        }
        return false;
    }


    diff_hours(dt2: any, dt1: any) {
        var diff = (dt2.getTime() - dt1.getTime()) / 60000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    }


    downloadInvoice(pPlantID) {

        let plant_request_id = this.getPlantRequestId(pPlantID);
        if (plant_request_id) {
            this._historyService.downloadInvoiceFromDMS('PlantMap_Invoice_' + plant_request_id + '.pdf');
            // this._fileService.getMiscSignedDownloadRequest("PlantMap_Invoice_" + plant_request_id + '.pdf');
        } else {
            console.error('Plant request ID not found.');
        }
    }
    /*
    
        downloadInvoice(pPlantID) {
            //this._fileService.getMiscSignedDownloadRequest('Invoice.pdf');
            let pmByPlantID = this.vPlantLists.filter(
                plantstatus => plantstatus.plant_request_id === pPlantID);
            this._fileService.getMiscSignedDownloadRequest('PlantMap_Invoice_'+pPlantID+'.pdf');
            //this._fileService.getMiscSignedDownloadRequest(pPlantID+'.pdf');
        }
    */
    downloadPlantmap(pPlantID) {
        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantstatus => plantstatus.plant_record_id === pPlantID);

            if (pmByPlantID.length > 0) {
                var test: any = pmByPlantID[0].plant_request_id;
                //this._fileService.getPlantMapSignedDownloadRequest('00099');
                this._fileService.getPlantMapSignedDownloadRequest(pmByPlantID[0].plant_request_id);

            }
        }
    }

    downloadPlantmapFromDMS(arg: any) {
        let plant_request_id = this.getPlantRequestId(arg);
        if (plant_request_id) {
            let fileName = `PRP_${plant_request_id}.zip`;
            this._historyService.downloadZipFileFromDMS(fileName);
        } else {
            console.error('Plant request ID not found.');
        }
    }

    // Function to filter and get the plant_request_id
    getPlantRequestId = (id: number): string | undefined => {
        const record = this.vPlantLists.find(r => r.plant_record_id === id);
        return record ? record.plant_request_id : undefined;
    }


    RegenerateMap(pPlantID) {
        this.vDisableButton = true;
        this._ReportService.gisPlantmapHit(pPlantID).then(
            (resolve) => {
                //this.vRegenerateMapStatus = this._ReportService.getRegenerateMapStatus();                
                //if(this.vRegenerateMapStatus === 1)
                //{
                if (this.vPlantSearchBy != 'applicationDate') {
                    this._ReportService.loadPlantmapAdmin(this.vPageNumber, this.vPageSize, this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus, 0, "").then(
                        (resolve) => {
                            this.vLoadingPlant = false;
                            this.vPlantLists = this._ReportService.getCustomerPlantList();
                        },
                        (reject) => {
                            this.vLoadingPlant = false;
                        }
                    );
                }
                else {
                    this._ReportService.loadPlantmapDateAdmin(this.vPageNumber, this.vPageSize, this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy, this.vPlantStatus, 0, "").then(
                        (resolve) => {
                            this.vLoadingPlant = false;
                            this.vPlantLists = this._ReportService.getCustomerPlantList();
                        },
                        (reject) => {
                            this.vLoadingPlant = false;
                        }
                    );
                }
                //}
                // else
                // {
                //     this.vDisableButton = false;
                // }                
            },
            (reject) => { }
        );

	this.vDisableButton = false;
    }

    //Kowsalya
    downloadHistory() {

        if (this.vPlantSearchBy != 'applicationDate') {
            console.log("Line 230", this.vPlantSearchBy, this.vPlantFilterBy);
            this._ReportService.getHistoryExcel(this.vPlantSearchBy, this.vPlantFilterBy.trim());
        }
        else if (this.vPlantFromDate != null && this.vPlantToDate) {
            console.log("Line 235", this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy);
            this._ReportService.getHistoryExcelBydate(this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy);
        }
        else {
            if (this.vPlantFromDate == null) {
                this._popupService.openGeneralConfirmationPopup('Notice', 'You have not select the Purchase Date range. Please select the required From Date and To Date.', '', false, false);
            }
            else {
                this._popupService.openGeneralConfirmationPopup('Notice', 'You have not select the Purchase Date range. Please select the required From Date and To Date.', '', false, false);
            }
        }

    } //Kowsalya



    refreshPlant() {
        if (this.vPlantSearchBy != 'applicationDate') {
            this.filterPlant();
        }
        else {
            if (this.vPlantFromDate != null && this.vPlantToDate) {
                this.filterPlantDate();

            }
            else {
                if (this.vPlantFromDate == null) {
                    this._popupService.openGeneralConfirmationPopup('Notice', 'You have not select the Purchase Date range. Please select the required From Date and To Date.', '', false, false);
                }
                else {
                    this._popupService.openGeneralConfirmationPopup('Notice', 'You have not select the Purchase Date range. Please select the required From Date and To Date.', '', false, false);
                }
            }
        }
    }

    isLoading() {
        return this._ReportService.isLoading();
    }
    checkDisableStatus() {
        return this.vDisableButton;
    }

    checkDisableStatus1() {

        this.vDisableButton = true;
        //alert(this.vDisableButton);
        return this.vDisableButton;
    }


    filterPlant() {
        this.vPageNumber = 0;
        this.vLoadingPlant = true;
        this.resettedPlantTable = 0;
        this._ReportService.loadTotalCustomerPlantAdmin(this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus).then(
            (resolve) => {
                this._ReportService.loadPlantmapAdmin(0, this.vPageSize, this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus, 0, "").then(
                    (resolve) => {
                        this.vLoadingPlant = false;
                        this.totalPlantmapRecords = this._ReportService.getTotalCustomerPlantmap();
                        this.vPlantLists = this._ReportService.getCustomerPlantList();
                    },
                    (reject) => {
                        this.vLoadingPlant = false;
                    }
                );
            },
            (reject) => {
                this.vLoadingPlant = false;
            }
        );
    }

    filterPlantDate() {
        this.vPageNumber = 0;
        this.vLoadingPlant = true;
        this.resettedPlantTable = 0;
        this._ReportService.loadTotalCustomerPlantDateAdmin(this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy, this.vPlantStatus).then(
            (resolve) => {
                this._ReportService.loadPlantmapDateAdmin(0, this.vPageSize, this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy, this.vPlantStatus, 0, "").then(
                    (resolve) => {
                        this.vLoadingPlant = false;
                        this.totalPlantmapRecords = this._ReportService.getTotalCustomerPlantmap();
                        this.vPlantLists = this._ReportService.getCustomerPlantList();
                    },
                    (reject) => {
                        this.vLoadingPlant = false;
                    }
                );
            },
            (reject) => {
                this.vLoadingPlant = false;
            }
        );
    }

    resetPlant() {
        this.resetPlantFilter();
        this.vPlantSearchBy = this.getSearchBy('plantmap')[0].type;
        this.filterPlant();
    }


    //Kowsalya
    getrequestId(pPlantID) {
        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantrecord => plantrecord.plant_request_id === pPlantID);

            if (pmByPlantID.length > 0) {
                this.viewPlantmap(pmByPlantID[0].plant_record_id);
            }
        }
    }

    getDetailPlantmap() {
        return this._PlantmapAdminAllComponent.getDetailPlantmap();
    }

    viewPlantmap(pPlantID) {
        this._PlantmapAdminAllComponent.viewPlantmap(pPlantID);
    }
    accessstatus() {
        var access = JSON.parse(this._storageService.getLocalItem('access'));
        if (this.actionChecking('MANINU', access) && this.actionChecking('MANEXU', access) && !(this.actionChecking('MANPL', access))) { // ADMN 
            return false;
        }
        else {
            return true;
        }
    }
    actionChecking(type, accesses) {
        for (var access of accesses) {
            if (access == type) {
                return true;
            }
        }
        return false;
    }
    //Kowsalya

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/admin/components/admin-report.component.ts